import { useQuery } from '@tanstack/react-query'
import { queryDeskCounts } from 'supabase/desk'

/**
 * The four tab badges, from desk_counts() only (D-03). Refetched every 60 s so
 * new editor output shows up while the desk is open; deliberately no
 * `refetchIntervalInBackground`, a hidden tab does not need to keep asking.
 * Keyed under 'desk' so every decision refreshes the badges.
 */
export const useQueryDeskCounts = () => {
  const { isLoading, isError, error, data } = useQuery({
    queryKey: ['desk', 'counts'],
    queryFn: queryDeskCounts,
    refetchInterval: 60_000
  })

  return {
    isLoading,
    isError,
    error,
    counts: data
  }
}
